import type { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";

const Home = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

function RouteFallback() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-white/80">
      Loading...
    </div>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<RouteFallback />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<RouteFallback />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
